module.exports = __webpack_public_path__ + "static/img/ht.d2c21946.svg";